/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import type { TivoPayloadAction } from '../../core/tivo/tivo-redux-wrapper';
import { IS_SIDEBAR_NAVIGATION_MENU_ACTIVE } from './sidebarnavigationmenu.types';

export const setIsSidebarNavigationMenuActiveAction = (
    isSidebarNavigationMenuActive: boolean,
): TivoPayloadAction<{ isSidebarNavigationMenuActive: boolean }> => ({
    type: IS_SIDEBAR_NAVIGATION_MENU_ACTIVE,
    payload: {
        isSidebarNavigationMenuActive,
    },
});
